import pako from "pako";
import axios from "axios";

import store from "@/global/store/store";
import { handleGetUpdatedAccountGroup } from "@/shared/modules/PurchaseSeats/Packs/packs.utils";

export const api = axios.create();
export const apiClient = api;

let didInitInterceptors = false;

export function interceptAxios() {
  if (didInitInterceptors) return;
  didInitInterceptors = true;

  api.interceptors.request.use(
    (config) => {
      if (typeof window !== "undefined") {
        const user = store.getState()?.user;
        if (user) {
          config.headers!["Authorization"] = `Bearer ${user.token}`;

          const teamSchema = window.location.pathname.split("/")[1];
          if (teamSchema) {
            const updatedAccountGroup =
              handleGetUpdatedAccountGroup(teamSchema);
            if (
              updatedAccountGroup !== undefined &&
              updatedAccountGroup !== null &&
              updatedAccountGroup?.length
            ) {
              config.headers!["Account-Group"] = updatedAccountGroup;
            }
          }

          const recipientUser =
            store.getState().data.purchaseSeats.recipientUser;
          // prettier-ignore
          if (recipientUser) {
            config.headers!["Recipient-User-Email"] = recipientUser.email;
            config.headers!["Recipient-User-Account-ID"] = recipientUser.accountId;
            config.headers!["Recipient-User-Phone-Number"] = recipientUser.phoneNumber;
          }
        }
      }

      // ✅ compress big bodies
      if (config.data && shouldCompress(config.data)) {
        try {
          const dataString =
            typeof config.data === "string" ? config.data : JSON.stringify(config.data);

          const compressed = pako.gzip(dataString);

          // IMPORTANT: keep it as binary, not JSON
          config.data = new Blob([compressed], { type: "application/octet-stream" });

          config.headers = config.headers || {};
          config.headers["Content-Encoding"] = "gzip";
          // Often safer than application/json since body is gzipped bytes:
          config.headers["Content-Type"] = "application/octet-stream";
          // Optional but sometimes helpful:
          config.headers["Accept-Encoding"] = "gzip";
        } catch (e) {
          // fall back to uncompressed
          console.error("gzip failed:", e);
        }
      }

      return config;
    },
    (error) => {
      return Promise.reject(error);
    }
  );
}

function shouldCompress(data: unknown) {
  const MIN_SIZE_TO_COMPRESS = 1024; // 1kb
  try {
    const s = typeof data === "string" ? data : JSON.stringify(data);
    return s.length > MIN_SIZE_TO_COMPRESS;
  } catch {
    return false;
  }
}

interceptAxios();
